import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { IMachine } from '@models';

@Component({
    templateUrl: './machine-robot-versions.modal.html',
    styleUrls: ['./machine-robot-versions.modal.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MachineRobotVersionsModalComponent
    extends UiModalComponent<IMachine> {

    public onClose() {
        this._dialogRef.close();
    }
}
